import { useTranslation } from 'react-i18next';

import { DataPanelInlineItem } from '@/ui';
import { openEditCallerNameDialog } from '../../actions';

export type CallerFullNamePanelItemProps = {
  incidentId: string;
  callerFullName: string | null;
  editable?: boolean;
};

export function CallerFullNamePanelItem({ incidentId, callerFullName, editable = false }: CallerFullNamePanelItemProps) {
  const { t } = useTranslation();

  return (
    <DataPanelInlineItem
      title={t('Incident_InfoPanel_Name')}
      value={callerFullName ?? undefined}
      editable={editable}
      showEmptyPlaceholder
      onEditClick={() => openEditCallerNameDialog(incidentId, callerFullName)}
    />
  );
}
